'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.Parser = exports.FetchForm = exports.components = undefined;

var _Webform = require('./Webform');

var _Webform2 = _interopRequireDefault(_Webform);

var _TextArea = require('./TextArea');

var _TextArea2 = _interopRequireDefault(_TextArea);

var _CheckboxField = require('./CheckboxField');

var _CheckboxField2 = _interopRequireDefault(_CheckboxField);

var _EmailField = require('./EmailField');

var _EmailField2 = _interopRequireDefault(_EmailField);

var _PhoneField = require('./PhoneField');

var _PhoneField2 = _interopRequireDefault(_PhoneField);

var _Date = require('./Date');

var _Date2 = _interopRequireDefault(_Date);

var _ParagraphField = require('./ParagraphField');

var _ParagraphField2 = _interopRequireDefault(_ParagraphField);

var _SelectField = require('./SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _RadioField = require('./RadioField');

var _RadioField2 = _interopRequireDefault(_RadioField);

var _FetchForm = require('./FetchForm');

var _FetchForm2 = _interopRequireDefault(_FetchForm);

var _Fieldset = require('./Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _IBAN = require('./IBAN');

var _IBAN2 = _interopRequireDefault(_IBAN);

var _Address = require('./Address');

var _Address2 = _interopRequireDefault(_Address);

var _Hidden = require('./Hidden');

var _Hidden2 = _interopRequireDefault(_Hidden);

var _RangeField = require('./RangeField');

var _RangeField2 = _interopRequireDefault(_RangeField);

var _Wizard = require('./Wizard');

var _Wizard2 = _interopRequireDefault(_Wizard);

var _Relation = require('./Relation');

var _Relation2 = _interopRequireDefault(_Relation);

var _FormRow = require('./FormRow');

var _FormRow2 = _interopRequireDefault(_FormRow);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _Number = require('./Number');

var _Number2 = _interopRequireDefault(_Number);

var _Converse = require('./Converse');

var _Converse2 = _interopRequireDefault(_Converse);

var _label = require('./WebformElement/styled/label');

var _label2 = _interopRequireDefault(_label);

var _SubmitButton = require('./SubmitButton');

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {

  // Webform core elements
  checkbox: _CheckboxField2.default,
  date: _Date2.default,
  email: _EmailField2.default,
  fieldset: _Fieldset2.default,
  hidden: _Hidden2.default,
  radios: _RadioField2.default,
  range: _RangeField2.default,
  select: _SelectField2.default,
  tel: _PhoneField2.default,
  textfield: _Input2.default,
  textarea: _TextArea2.default,
  number: _Number2.default,
  webform_wizard_pages: _Wizard2.default,
  webform_wizard_page: _Fieldset2.default,
  webform_message: _ParagraphField2.default,
  webform_actions: _SubmitButton2.default,

  // Custom elements
  dutch_address: _Address2.default,
  date_of_birth: _Date2.default,
  iban_wrapper: _FormRow2.default,
  iban: _IBAN2.default,
  natuurmonumenten_relation: _Relation2.default,
  natuurmonumenten_relation_address: _Relation2.default,
  webform_converse_payment: _Converse2.default,
  webform_element_converse_payment: _Converse2.default,

  // Legacy elements
  webform_email_custom: _EmailField2.default,
  webform_address_custom: _Address2.default,
  webform_checkbox_custom: _CheckboxField2.default,
  webform_select_custom: _SelectField2.default,
  webform_textarea_custom: _TextArea2.default,
  webform_radios_custom: _RadioField2.default,
  webform_telephone_custom: _PhoneField2.default,
  webform_textfield_custom: _Input2.default,
  webform_date_custom: _Date2.default,
  webform_dateofbirth: _Date2.default,
  webform_iban: _FormRow2.default,
  webform_relation_custom: _Relation2.default,
  webform_relation_postcode_custom: _Relation2.default,
  webform_number_custom: _Number2.default
};

exports.default = _Webform2.default;
exports.components = components;
exports.FetchForm = _FetchForm2.default;
exports.Parser = _Parser2.default;
exports.Label = _label2.default;